module.exports = __webpack_public_path__ + "static/image1-7f20afa812258834f392cd8b1fb8b62e.jpg";